import { useEffect, useState } from "react";

/**
 * Inline confirmation: a single button that swaps to "Confirmar?" on first click.
 * Works inside iframes/sandboxes where window.confirm is unreliable.
 */
export default function ConfirmButton({
  onConfirm,
  className = "btn btn-danger text-xs",
  confirmClassName = "btn text-xs bg-red-700 text-white border-red-700",
  label = <i className="fa-solid fa-trash"></i>,
  confirmLabel = "Confirmar?",
  testid,
  resetMs = 3000,
}) {
  const [armed, setArmed] = useState(false);

  useEffect(() => {
    if (!armed) return;
    const t = setTimeout(() => setArmed(false), resetMs);
    return () => clearTimeout(t);
  }, [armed, resetMs]);

  return (
    <button
      type="button"
      onClick={() => {
        if (!armed) { setArmed(true); return; }
        setArmed(false);
        onConfirm();
      }}
      className={armed ? confirmClassName : className}
      data-testid={testid}
    >
      {armed ? confirmLabel : label}
    </button>
  );
}
